import {
  LANGUAGE_VALUE,
  TCountryDomainCode,
  TLANGUAGE_VALUE,
  TUrlPrefix,
  countryDomainCode,
  languageMap,
  urlPrefix,
} from '../../../../constants/staticPageConstants';
import { TDropdownList } from '../../../Header/DynamicHeader/Dropdown/DropdownComponent';
import { ISINGLE_POST } from '../types';
import { generateLink } from './utils';

export const generateLanguageTags = (
  isMultiLang: boolean,
  pageData: ISINGLE_POST
): { link: string; lang: string }[] => {
  const HREF_TAGS = [];
  const { linked_languages, language, domain, permalink } = pageData;

  if (isMultiLang) {
    const X_DEFAULT_LINK = generateLink(permalink, LANGUAGE_VALUE[1], domain);
    const languageValue =
      LANGUAGE_VALUE[language as keyof typeof LANGUAGE_VALUE];

    const POST_SELF_TAG_LINK = generateLink(permalink, languageValue, domain);
    const langValue =
      languageMap[LANGUAGE_VALUE[language as keyof typeof LANGUAGE_VALUE]] ||
      urlPrefix[languageValue as TUrlPrefix];
    HREF_TAGS.push({
      link: X_DEFAULT_LINK,
      lang: 'x-default',
    });

    HREF_TAGS.push({
      link: POST_SELF_TAG_LINK,
      lang: `${langValue}-${countryDomainCode[domain as TCountryDomainCode]}`,
    });

    linked_languages?.forEach((post) => {
      const ALT_LANG_LINK = generateLink(
        permalink,
        LANGUAGE_VALUE[post.language_id as TLANGUAGE_VALUE],
        domain
      );
      const altLangValue =
        languageMap[post.language_name] ||
        urlPrefix[languageValue as TUrlPrefix];
      HREF_TAGS.push({
        link: ALT_LANG_LINK,
        lang: `${altLangValue}-${
          countryDomainCode[domain as TCountryDomainCode]
        }`,
      });
    });
  }

  return HREF_TAGS;
};

export const HeaderLanguageDropDownAe = (
  isMultiLang: boolean,
  permalink: string | null = ''
): TDropdownList | undefined => {
  const DROPDOWN_DATA = [
    {
      name: 'English',
      name_ar: 'English',
      link: `https://www.cleartax.com/ae/${permalink}`,
    },
    {
      name: 'العربية',
      name_ar: 'العربية',
      link: `https://www.cleartax.com/ae/ar/${permalink}`,
    },
  ];
  if (isMultiLang) {
    return DROPDOWN_DATA;
  }
  return;
};
